import React, { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [modal, setModal] = useState(null);

  const showAlert = useCallback((message, title = 'Notice') => {
    return new Promise((resolve) => {
      setModal({ type: 'alert', title, message, resolve });
    });
  }, []);

  const showConfirm = useCallback((message, title = 'Are you sure?') => {
    return new Promise((resolve) => {
      setModal({ type: 'confirm', title, message, resolve });
    });
  }, []);

  const handleClose = (result) => {
    if (modal) modal.resolve(result);
    setModal(null);
  };

  return (
    <ModalContext.Provider value={{ showAlert, showConfirm }}>
      {children}
      {modal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6"
            style={{ fontFamily: 'inherit' }}>
            <h2 className="text-lg font-semibold mb-2"
              style={{ color: '#2C2C2C' }}>
              {modal.title}
            </h2>
            <p className="text-sm mb-6 whitespace-pre-line"
              style={{ color: '#555' }}>
              {modal.message}
            </p>
            <div className="flex justify-end gap-3">
              {modal.type === 'confirm' && (
                <button
                  onClick={() => handleClose(false)}
                  className="px-4 py-2 rounded-lg text-sm font-medium border"
                  style={{ borderColor: '#ddd', color: '#555' }}>
                  Cancel
                </button>
              )}
              <button
                onClick={() => handleClose(true)}
                className="px-4 py-2 rounded-lg text-sm font-medium text-white"
                style={{ backgroundColor: '#E8856A' }}>
                {modal.type === 'confirm' ? 'Confirm' : 'OK'}
              </button>
            </div>
          </div>
        </div>
      )}
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}